import { removeNodesFromHTML } from '@Common/handlers/helper';
import { QuillEditorIDS } from '@Common/handlers/quillEditor';
import { RootState } from '@Common/models/redux/store';
import { renderToString } from 'react-dom/server';
import { CitationElement } from 'src/citation-generator/components/CitationElement';
import { getBibSectionTitle } from 'src/citation-generator/utils';
import { getContentFromEditor, getContentFromEditorByRemovingPageWrapper } from '.';
import { ElementsToSkipForSaving } from '../constants/common.constants';

export function convertToExportableContent(
  html: string,
  citations: RootState['ctgr']['citationList'],
  citationStyle: RootState['ctgr']['citationStyle'],
  citedDataById: RootState['ctgr']['citedDataById']
) {
  const richText = html;
  const citationDiv = document.createElement('div');
  const headerElement = document.createElement('h3');
  headerElement.innerText = getBibSectionTitle(citationStyle);
  headerElement.style.textAlign = 'center';
  citationDiv.appendChild(headerElement);

  const citationsHtml = renderToString(
    <>
      {citations?.map?.((citation) => (
        <p
          key={`${citation.refId}_file_export`}
          style={{
            textIndent: '-0.7cm',
            marginLeft: '+0.7cm',
            marginTop: 10,
            marginBottom: 10,
            fontSize: 14,
          }}
        >
          <CitationElement
            content={citedDataById[citation.refId].full}
            citationNumber={citedDataById[citation.refId].citationNumber}
          />
        </p>
      ))}
    </>
  );

  return `${richText}<br/><br/><br/>${citationDiv.outerHTML}<br/><br/><br/>${citationsHtml}`;
}

export function getRichTextWithCitations(
  citations: RootState['ctgr']['citationList'],
  citationStyle: RootState['ctgr']['citationStyle'],
  citedDataById: RootState['ctgr']['citedDataById']
) {
  const html = removeNodesFromHTML(
    getContentFromEditor(QuillEditorIDS.RESEARCH_EDITOR),
    ElementsToSkipForSaving
  ).html;
  return convertToExportableContent(html, citations, citationStyle, citedDataById);
}
